import { css } from '@emotion/react';
import { PageProps,withPrefix } from 'gatsby';
import { ContactSection } from '@/components/general/ContactSection';
import { Layout } from '@/components/general/Layout';
import { PageHeader } from '@/components/general/PageHeader';
import { Seo } from '@/components/general/Seo';
import { ButtonLink } from '@/components/shared/ButtonLink';
import {
  FeatureCard1,
  FeatureCard2,
  FeatureCard3,
  FeatureCard4,
  FeatureCard5,
  FeatureCard6,
} from '@/components/top-page/FeatureCard';
import { pagesPath } from '@/lib/pagesPath';
import { getScreen } from '@/styles/media-query';

const Page: React.FC<PageProps> = ({ location }) => (
  <Layout location={location}>
    <Seo
      title="スタートアップのIPO・M&A準備を効率化｜オンラインで一元管理できるIPO準備クラウド"
      description="【Uniforce】IPO・M&A準備を効率化するクラウドサービス。資本政策表の作成や内部統制の診断、人事労務の課題まで一元管理。専門アドバイザーのサポート付きで、上場経験がなくても必要なタスクを逆引きで把握できる機能も提供。"
    />
    <PageHeader
      css={css`
        margin-bottom: -80px;

        @media ${getScreen('pc')} {
          margin-bottom: -192px;
        }
      `}
      en="FEATURE"
      title="Uniforceの特徴"
      readText={
        <>
          IPO準備業務の課題を解決し
          <br
            css={css`
              @media ${getScreen('pc')} {
                display: none;
              }
            `}
          />
          「上場までの道のりを完全サポート」するための
          <br />
          Uniforceの特徴をご紹介します。
        </>
      }
    >
      <div
        css={css`
          pointer-events: none;
          position: absolute;
          right: calc(50% + 331px);
          bottom: 0;

          @media ${getScreen('pc', '未満')} {
            display: none;
          }
        `}
      >
        <img
          src={withPrefix('/images/features/header-decoration.png')}
          width="344"
          height="184"
          alt=""
        />
      </div>
    </PageHeader>
    <FeatureSection
      css={css`
        [data-part='background'] {
          background: linear-gradient(55deg, #f0fcfb 0%, #ffffff 100%);
        }
      `}
    >
      <FeatureCard1 />
    </FeatureSection>
    <FeatureSection
      css={css`
        margin-top: -80px;

        @media ${getScreen('pc')} {
          margin-top: -192px;
        }

        [data-part='background'] {
          background: linear-gradient(68deg, #f0fcfb 0%, #ffffff 100%);
        }
      `}
      rounded
    >
      <FeatureCard6 />
    </FeatureSection>
    <FeatureSection
      css={css`
        margin-top: -80px;

        @media ${getScreen('pc')} {
          margin-top: -192px;
        }

        [data-part='background'] {
          background: linear-gradient(68deg, #f0fcfb 0%, #ffffff 100%);
        }
      `}
      rounded
    >
      <FeatureCard5 />
    </FeatureSection>
    
    <FeatureSection
      css={css`
        margin-top: -80px;

        @media ${getScreen('pc')} {
          margin-top: -192px;
        }

        [data-part='background'] {
          background: linear-gradient(68deg, #f0fcfb 0%, #ffffff 100%);
        }
      `}
      rounded
    >
      <FeatureCard4 />
    </FeatureSection>
    <FeatureSection
      css={css`
        margin-top: -80px;

        @media ${getScreen('pc')} {
          margin-top: -192px;
        }

        [data-part='background'] {
          background: linear-gradient(68deg, #f0fcfb 0%, #ffffff 100%);
        }
      `}
      rounded
    >
      <FeatureCard3 />
    </FeatureSection>
    <FeatureSection
      css={css`
        margin-top: -80px;

        @media ${getScreen('pc')} {
          margin-top: -192px;
        }

        [data-part='background'] {
          background: linear-gradient(310deg, #f0fcfb 0%, #ffffff 100%);
        }
      `}
      rounded
    >
      <FeatureCard2 />
      <ButtonLink
        css={css`
          margin: 120px auto 0;

          @media ${getScreen('pc')} {
            width: 188px;
          }
        `}
        to={pagesPath.tool.$url()}
        variant="top-more"
      >
        機能一覧
      </ButtonLink>
    </FeatureSection>
    <ContactSection
      css={css`
        margin-top: -80px;

        @media ${getScreen('pc')} {
          margin-top: -200px;
        }
      `}
      title1="Uniforce IPO準備クラウドで"
      title2="「IPOの準備を効率的」"
      title3="に"
      title4="進めませんか？"
      text="IPO準備クラウドの機能詳細や無料デモのご相談はこちら"
      rounded
    />
  </Layout>
);

export default Page;

const FeatureSection: React.FC<{
  className?: string;
  children?: React.ReactNode;
  rounded?: boolean;
}> = ({ className, children, rounded }) => {
  return (
    <section
      css={css`
        padding: 120px 30px 120px;
        position: relative;
        pointer-events: none;
        overflow: hidden;

        ${rounded &&
        css`
          z-index: 1;
        `}

        @media ${getScreen('pc')} {
          padding: 320px 30px 160px;
        }
      `}
      className={className}
    >
      {/* 背景装飾・丸み */}
      <div
        css={css`
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
          width: 100%;
          height: 100%;
          pointer-events: none;

          ${rounded &&
          css`
            mask: url(${withPrefix('images/section-round-sp.png')}) center top/100% 64px
                no-repeat,
              linear-gradient(0deg, #000 0%, #000 100%) center 63px/100% 100%
                no-repeat;
          `}

          @media ${getScreen('pc')} {
            ${rounded &&
            css`
              mask: url(${withPrefix('/images/section-round-pc.png')}) center top/100% 192px
                  no-repeat,
                linear-gradient(0deg, #000 0%, #000 100%) center 191px/100% 100%
                  no-repeat;
            `}
          }
        `}
        data-part="background"
      ></div>
      <div
        css={css`
          pointer-events: all;
        `}
      >
        {children}
      </div>
    </section>
  );
};
